<template>
    <div class="list">
        <el-form :inline="true" size="small" class="demo-form-inline">
            <el-form-item class="add">
                <el-button type="primary" size="small" icon="el-icon-plus" @click="jumpLink()">关联文章</el-button>
            </el-form-item>
        </el-form>

        <el-table v-loading="listLoading" :data="list" border style="width: 100%" align="center">
            <el-table-column label="文章封面" align="center">
                <template slot-scope="scope">
                    <viewer v-if="scope.row.img">
                        <img :src="imgDomain + scope.row.img" class="viewer-img">
                    </viewer>
                </template>
            </el-table-column>
            <el-table-column prop="title" label="文章名称" align="center" />
            <el-table-column prop="article_class_name" label="所属分类" align="center" />
            <el-table-column prop="article_tag_name" label="所属标签" align="center" />
            <el-table-column label="状态" width="80" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.status === 1 ? '显示' : '隐藏' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间"align="center" />
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="danger" size="mini" class="op_buttton" @click="showDialog(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="page"><pagination v-show="total > 0" :total="total" :page.sync="listQuery.page_index" :limit.sync="listQuery.page_size" @pagination="getList" /></div>

        <div class="back" @click="back">
            <el-button type="primary">返回</el-button>
        </div>
    </div>
</template>
<script>
import { getArticleRecommendRecord, addArticleRecommendRecord, deletArticleRecommendRecord } from '@/api/college.js';
import Pagination from '@/components/Pagination';
import CommonDialog from '@/components/CommonDialog';
import operations from '../../mixins/operations';
import { imgDomain } from '@/configs/env';
export default {
    components: { Pagination, CommonDialog },
    mixins: [operations],
    data() {
        return {
            imgDomain,
            showBtns: false,
            dialogTitle: "",
            dialogType: "",
            list: [],
            dialogVisible: false,
            total: 0,
            listQuery: {
                page_index: 1,
                page_size: 10
            },
            listLoading: false
        };
    },

    async mounted() {
        this.getList();
    },

    methods: {
        async getList(params = this.listQuery) {
            this.listLoading = true;
            const { total, data } = await getArticleRecommendRecord(params);
            this.listLoading = false;
            this.total = total;
            this.list = data;
        },

        back() {
            this.$router.go(-1);
        },

        jumpLink(value, scope) {
            this.$router.push({
                path: "./related-articles",
                query: {

                }
            })
        },

        showDialog(id) {
            this.$confirm(`是否删除该关联文章？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async() => {
                const res = await deletArticleRecommendRecord(id);
                if (res == true) {
                    this.getList();
                    this.$notify({ title: '关联文章删除成功', type: 'success' });
                } else {
                    this.$notify.error({ title: '操作失败' });
                }
            }).catch(() => {

            })
        }
    }
};
</script>

<style lang="less" scoped>
    .list{
        .add{
            float: right;
            margin-bottom: 20px;
        }
        .button_wrap{
            text-align: center;
            margin-top: 30px;
        }

        .op_buttton{
            margin-bottom: 10px;
        }
        .viewer-img{
            width: 124px;
            height: 80px;
        }
        .back{
            text-align: center;
            margin-top: 30px;
        }
    }
</style>
